import { Navigate, useParams } from "react-router-dom";

/**
 * 레거시 URL → 신규 URL 리다이렉트
 *
 * 1) route param에 branchUid가 있으면 그대로 사용 (e.g. branch/:branchUid/...)
 * 2) query param ?branch-uid=X 가 있으면 URL에 삽입
 * 3) 둘 다 없으면 fallback("/")로 이동
 */
export function LegacyRedirect({ to }: { to: string }) {
  const params = useParams();
  const searchParams = new URLSearchParams(window.location.search);

  const branchUid =
    params.branchUid ?? searchParams.get("branch-uid") ?? undefined;

  const resolved = branchUid
    ? to.replace(":branchUid", branchUid)
    : to.includes(":branchUid")
      ? "/"
      : to;

  return <Navigate to={resolved} replace />;
}
